import { PageWithGraphs } from 'common/components/Layouts/PageLayout/PageWithGraphs.tsx';
import { ActivityLogTabs } from '@/activityLog/layout/ActivityLogTabs.tsx';
import { ProductManagementFiltersURLParser } from '@/activityLog/productsManagement/Filters/ProductManagementFiltersURLParser.tsx';
import { TabPanelWithErrorHandling } from 'common/components/AppLayout/Components/TabPanelWithErrorHandling.tsx';
import { useTranslation } from 'react-i18next';
import {
  TableLayout,
  TableLayoutActions,
  TableLayoutTable,
} from 'common/components/Layouts/TableLayout/TableLayout.tsx';
import { ProductsManagementFilters } from '@/activityLog/productsManagement/Filters/ProductsManagementFilters.tsx';
import { RefetchQueryButton } from 'common/components/Queries/RefetchQueryButton.tsx';
import { productsManagementQueries } from '@/activityLog/productsManagement/queries/productsManagementQueries.ts';

import { TableSkeleton } from 'common/components/Table/TableSkeleton.tsx';
import { Suspense } from 'react';
import { ProductsManagementTable } from '@/activityLog/productsManagement/Inventory/ProductsManagementTable.tsx';
import { ProductsManagementChips } from '@/activityLog/productsManagement/Filters/ProductsManagementChips.tsx';
// import { ProductsManagementsDownloadError } from '@/activityLog/productsManagement/Reports/ProductsManagementsDownloadError.tsx';
import { ProductsManagementTemplateDownloadButton } from '@/activityLog/productsManagement/Templates/ProductsManagementTempleteDownloadButton.tsx';
import { ProductsManagementUploadButton } from '@/activityLog/productsManagement/Inventory/ProductsManagementUploadButton.tsx';
import { useTabNavigationSetter } from 'common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter.ts';
import { activityLogNavigationAtom } from 'atoms/pages/pages.ts';
import { useProductsManagementUrlFromFilters } from '@/activityLog/productsManagement/hooks/useProductsManagementUrlFromFilters.ts';

export const ProductManagement = () => {
  const { t } = useTranslation();

  const url = useProductsManagementUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: activityLogNavigationAtom, routeToSet: url });

  return (
    <PageWithGraphs>
      <ActivityLogTabs>
        <TabPanelWithErrorHandling name={t('activityLog.tabs.productsManagement')}>
          <ProductManagementFiltersURLParser>
            <TableLayout firstTab>
              <ProductsManagementFilters />
              <ProductsManagementChips />
              <TableLayoutActions>
                <RefetchQueryButton queryKey={productsManagementQueries.all} />
                {/*<ProductsManagementsDownloadError />*/}
                <ProductsManagementTemplateDownloadButton />
                <ProductsManagementUploadButton />
              </TableLayoutActions>
              <TableLayoutTable>
                <Suspense fallback={<TableSkeleton showEndSkeleton />}>
                  <ProductsManagementTable />
                </Suspense>
              </TableLayoutTable>
            </TableLayout>
          </ProductManagementFiltersURLParser>
        </TabPanelWithErrorHandling>
      </ActivityLogTabs>
    </PageWithGraphs>
  );
};
